// removed by extract-text-webpack-plugin
module.exports = {"containerColumns":"fi_fj","items":"fi_fk","item":"fi_fl","avatar":"fi_fm","reviewText":"fi_fn","authorDetails":"fi_fo","createdDate":"fi_fp"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventDetail/OrganiserReviews/styles.module.css
// module id = 1250
// module chunks = 27